<template>
	<div>
		<section class="top_article relative over--hide body--white">
			<div class="no_mobile cover absolute img-cover">
				<img :src="typeof page.acf.top_cover.desktop == 'object' ? page.acf.top_cover.desktop.url : ''" />
			</div>
			<div class="mobile_only cover absolute img-cover">
				<img :src="typeof page.acf.top_cover.mobile == 'object' ? page.acf.top_cover.mobile.url : ''" />
			</div>
			<div class="top_banner_in absolute">
				<div class="inner_width flex flex--top flex--column h-100 tx--white">
					<div class="article_top_title bg--yellow center width-970">
						<h1 class="cat_title title--big tx--green">
							{{ page.title }}
						</h1>
						<div class="text tx--green">
							{{ page.acf.subtitle }}
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="main_article sec--pad bg--white">
			<div class="inner_width">
				<div class="width-970 main_tx text has--p" v-html="page.post_content"></div>
			</div>
		</section>
		<section class="sec_recipe sec--pad--top">
			<div class="inner_width">
				<div class="width-970">
					<div
						class="recipe_img relative cover"
						v-lazy:background-image="
							typeof page.acf.recipe.image == 'object' ? page.acf.recipe.image.url : ''
						"
					>
						<div class="recipe_border"></div>
						<div class="recipe_slogen">המתכון של כרמלה</div>
					</div>
					<h2 class="cat_title title--big center">
						{{ page.acf.recipe.title }}
					</h2>
					<div class="cat_title recipe_sub center">
						{{ page.acf.recipe.subtitle }}
					</div>
					<div class="icons-contact flex flex--content--center">
						<a
							class="icon-cont ease flex flex--column flex--center img-b"
							:href="'https://wa.me/?text=' + currentUrl"
							target="_blank"
							><img :src="assets_url + '/layout/w-whatsapp.png'"
						/></a>
						<a
							class="icon-cont ease flex flex--column flex--center img-b"
							:href="'mailto:?subject=מתכון שאני חושב שתאהב&body=' + currentUrl"
							target="_blank"
							><img :src="assets_url + '/layout/w-mail.png'"
						/></a>
						<a
							class="icon-cont ease flex flex--column flex--center img-b"
							:href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(currentUrl)"
							target="_blank"
							><img :src="assets_url + '/layout/w-face.png'"
						/></a>
					</div>
					<div class="recipe_info main_tx text tx--green has--p flex">
						<div class="recipe_col1 m-100">
							<h2 class="has--border">מה צריך?</h2>
							<ul>
								<li v-for="(value, index) in page.acf.recipe.needs">
									{{ value.text }}
								</li>
							</ul>
						</div>
						<div class="recipe_col2 m-100">
							<h2 class="has--border">איך מכינים?</h2>
							<div class="conter_steps">
								<div class="conter_step" v-for="(value, index) in page.acf.recipe.stages">
									<span class="num-s">{{ index + 1 }}</span
									>{{ value.text }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="recipe_products sec--pad--top">
			<div class="inner_width">
				<div class="width-970">
					<h2 class="cat_title center">להוספה מהירה לעגלת הקניות:</h2>
					<div class="hp_products row flex flex--start products_wrap">
						<!-- products -->
						<Product
							ref="productComponent"
							v-bind:product="product"
							v-bind:index="index"
							v-for="(product, index) in pageProducts"
							:key="product.id"
						></Product>
					</div>
				</div>
			</div>
		</section>
		<Blog :posts="page.posts" v-if="typeof page.posts != 'undefined' && page.posts.length > 0" />
	</div>
</template>
<script>
	import arrowLeft from "../assets/img/arrow_l.svg";
	import arrowRight from "../assets/img/arrow_r.svg";
	import arrowLong from "../assets/img/arrow-long.svg";
	import CHEF from "../assets/img/chef.svg";
	import Slick from "vue-slick";
	import Product from "../components/Product/Product";
	import Blog from "../components/Home/Blogs.vue";
	import axios from "axios";

	export default {
		metaInfo() {
			title: wpData.pageData.hasOwnProperty("yoast_title") ? wpData.pageData.yoast_title : this.page.title;
		},
		data() {
			return {
				isPageLoading: true,
				assets_url: wpData.assets_url,
				currentUrl: document.URL,
				slickOptions: {
					rtl: true,
					dots: false,
					infinite: true,
					centerMode: false,
					slidesToShow: 3,
					slidesToScroll: 1,
					autoplay: false,
					autoplaySpeed: 2000,
					responsive: [
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 800,
							settings: {
								slidesToShow: 2,
								arrows: false,
								infinite: false,
							},
						},
						{
							breakpoint: 650,
							settings: {
								slidesToShow: 1,
								arrows: false,
								infinite: false,
							},
						},
					],
				},
			};
		},
		mounted() {},
		methods: {
			next() {
				this.$refs.blog.next();
			},
			prev() {
				this.$refs.blog.prev();
			},
		},
		computed: {
			page: function () {
				if (typeof wpData.pageData != "object") {
					return JSON.parse(wpData.pageData);
				}
				return wpData.pageData;
			},
			pageProducts: function () {
				let cPageData = wpData;
				if (typeof cPageData != "object") {
					cPageData = JSON.parse(wpData);
				}
				return cPageData.pageData.acf.products.filter((p) => p && p.id);
			},
		},
		components: {
			arrowRight,
			arrowLeft,
			CHEF,
			arrowLong,
			Slick,
			Product,
			Blog,
		},
	};
</script>
